import { DateTime } from 'luxon'

export function buildSessionNoteTitle(sessionTitle, sessionDate, timezone) {
  if (!sessionTitle) return null

  if (!sessionDate) return sessionTitle

  const dateTime = timezone
    ? DateTime.fromISO(sessionDate, { zone: timezone })
    : DateTime.fromISO(sessionDate)

  if (!dateTime.isValid) return sessionTitle

  const dateLabel = dateTime.toLocaleString(DateTime.DATE_MED)
  return `${dateLabel} - ${sessionTitle}`
}

export function sortNotesByUpdatedAt(notes) {
  return [...(notes || [])].sort((a, b) => {
    const dateA = new Date(a.updatedAt || a.createdAt).getTime()
    const dateB = new Date(b.updatedAt || b.createdAt).getTime()
    return dateB - dateA
  })
}

export function getLatestNote(notes) {
  return sortNotesByUpdatedAt(notes)[0] ?? null
}

export function formatCreateNoteInput(input) {
  const formatted = {
    content: input.content,
    notableId: String(input.notableId),
    notableType: input.notableType,
    title: input.title || null,
  }

  formatted.private = input.private ?? true

  return formatted
}

export function formatUpdateNoteInput(input) {
  const formatted = {
    id: String(input.id),
    content: input.content,
    title: input.title || null,
  }

  if (input.private !== undefined) {
    formatted.private = input.private
  }

  return formatted
}
